import { Brand } from '@blade/std-lib'

import type { Address } from '@root/entities/address/Address'

export const WalletAddressTypeId = 'tradebot-tma/WalletAddress'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WalletAddressTypeId = typeof WalletAddressTypeId
export type WalletAddress = Brand.Branded<Address, WalletAddressTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WalletAddress = Brand.nominal<WalletAddress>()
